import { Component, OnInit, OnDestroy, EventEmitter, Output } from '@angular/core';
import { BaseComponent } from 'app/shared/infrastructure/base.component'; // leaf import - do not revert to the barrel (app/shared/infrastructure), breaks ng test (circular dependency)
import { PatientBasicSearchFilter } from 'app/shared/models/queryModel';
import { FingerprintService, PatientService, SecuGenService } from 'app/shared/services';
import { PatientBasicSearchService } from 'app/shared/services/queryModel/patientBasicSearch';
import { switchMap, of } from 'rxjs';

@Component({
    selector: 'advance-search-advance-search-with-finger-print-cmp',
    templateUrl: './advance-search-with-finger-print.html',
})
export class AdvanceSearchWithFingerPrintComponent extends BaseComponent implements OnInit, OnDestroy {

    @Output() onSearch = new EventEmitter<any>();
    patientBasicSearchFilter: PatientBasicSearchFilter = new PatientBasicSearchFilter();
    isFingerprintSearch: boolean = false;
    showFingerprintPrompt: boolean = false;
    fingerprintPromptMessage: string = '';
    today: Date = new Date();
    minDate: Date = new Date(1900, 0, 1);

    constructor(private _patientBasicSearchService: PatientBasicSearchService,
        private _secuGenService: SecuGenService,
        private _fingerprintService: FingerprintService,
        private _patientService: PatientService
    ) {
        super();
    }

    ngOnInit() {
    }

    onSubmit() {
        if (this.isFingerprintSearch)
            return;
        // this variable to regardless  status for patient 
        const checkStatus = false;
        this._patientBasicSearchService.getSearchResult(this.patientBasicSearchFilter, checkStatus)
            .subscribe((data) => {
                this.onSearch.emit({ patientBasicSearchResult: data });

            });
    }

    ngOnDestroy() {
    }

    searchByFingerprint() {
        this.isFingerprintSearch = true;
        this.fingerprintPromptMessage = 'Please place your finger on the fingerprint device and hold steady...';
        this.showFingerprintPrompt = true;

        this._secuGenService.patientFingerprint().pipe(
            switchMap((response: any) => {
                if (response) {
                    this.fingerprintPromptMessage = 'Processing fingerprint... Please keep your finger steady.';

                    const templateBase64 = response.ISOTemplateBase64 || response.isoTemplateBase64;
                    return this._fingerprintService.identifyFingerprint(templateBase64);
                }
                return of(null);
            })
        ).subscribe({
            next: (value: any) => {
                if (value) {
                    this.patientBasicSearchFilter.patientId = value;
                    this.showFingerprintPrompt = false;
                    this.isFingerprintSearch = false;
                    this.onSubmit();
                }
            },
            error: (error) => {
                this.showError(error);
                this.showFingerprintPrompt = false;
                this.isFingerprintSearch = false;
            }
        });
    }

    cancelFingerprintSearch() {
        this.showFingerprintPrompt = false;
        this.isFingerprintSearch = false;
        this.fingerprintPromptMessage = '';
    }
}